export const getRoundedValue = (value, precision = 2) => Number.parseFloat(value).toFixed(precision);
